export const OtherWarehouseRouting = [
  {
    path: "/material/otherWarehouse/list",
    name: "basic-material-other-warehouse-list",
    meta: { title: "自定义入库申请" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-warehouse/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/otherWarehouse/create",
    name: "basic-material-other-warehouse-create",
    meta: { title: "新增自定义入库申请" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-warehouse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/otherWarehouse/edit/:id",
    name: "basic-material-other-warehouse-edit",
    meta: { title: "编辑自定义入库申请" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-warehouse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/otherWarehouse/detail/:id",
    name: "basic-material-other-warehouse-detail",
    meta: { title: "自定义入库申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-warehouse/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/otherWarehouse/flowPrint/:id",
    name: "basic-material-other-warehouse-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/other-warehouse/flow-print/index.vue"
      ),
  },
];
